import { Modal } from "ui/Modal"
import { Text, Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import { Button, Flex, Space } from "antd"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const DeleteClient = ({ open, onClose, handleDeleteClick, isClientLoading }) => {
  const { t } = useTranslation()

  return (
    <Modal open={open} onCancel={onClose} width={430} className={styles.deleteModal} centered>
      <Space className="w-full" direction="vertical" size={24}>
        <Flex justify="center">
          <WarningOutlinedWithBg />
        </Flex>
        <Flex vertical gap={16}>
          <Title level={3}>{t("client.delete_client.title")}</Title>
          <Text>
            {t("client.delete_client.description")} <br /> {t("client.delete_client.actionText")}
          </Text>
        </Flex>
        <Flex gap={12}>
          <Button variant="outlined" color="primary" size="large" onClick={onClose}>
            {t("global.cancel")}
          </Button>
          <Button type="primary" danger size="large" onClick={handleDeleteClick} disabled={isClientLoading}>
            {t("global.delete")}
          </Button>
        </Flex>
      </Space>
    </Modal>
  )
}

DeleteClient.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired,
  isClientLoading: PropTypes.bool.isRequired
}

export default DeleteClient
